import React, { useEffect, useState } from "react";
import "./HeroSection.css";

const HeroSection = ({ slides = [], bannerLink = "#", autoSlide = true, intervalTime = 4000 }) => {
  const [current, setCurrent] = useState(0);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!autoSlide) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, intervalTime);

    return () => clearInterval(interval);
  }, [slides.length, autoSlide, intervalTime]);

  const isMobile = screenWidth < 768;
  const isSmallMobile = screenWidth < 400;

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  if (!slides.length) return null;

  return (
    <section className="hero-container">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`hero-slide ${index === current ? "active" : ""}`}
        >
          <a
            href={bannerLink}
            target="_blank"
            rel="noopener noreferrer"
            className="hero-link"
          >
            <img
              src={isMobile ? slide.mobile : slide.desktop}
              alt={`slide-${index}`}
              className={`hero-image ${isSmallMobile ? "small-mobile" : ""}`}
            />
          </a>
        </div>
      ))}

      {/* SIDE ARROWS */}
      <button className="hero-arrow left" onClick={prevSlide}>
        ❮
      </button>
      <button className="hero-arrow right" onClick={nextSlide}>
        ❯
      </button>

      {/* DOTS */}
      <div className="hero-dots">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`dot ${i === current ? "active-dot" : ""}`}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSection;